import { addLocale, useLocale } from 'ttag';

export function getLocale() {
  return sessionStorage.getItem('lng') || 'en';
}

export function saveLocale(locale) {
  sessionStorage.setItem('lng', locale);
}

const locale = getLocale();

if (locale !== 'en') {
  const translationsObj = require(`./i18n/${locale}.po.json`);
  addLocale(locale, translationsObj);
  useLocale(locale);
}
